import * as React from 'react';

import CheckmateApiClient from '../../services/apiClient';
import { DisplayMessages } from '../../utilities/DisplayMessages';
import { ILoginUser } from '../../interfaces/IAccount';
import { IValidation } from '../../interfaces/IError';
import { Modal } from 'react-bootstrap';
import { useLoading } from '../../contexts/LoadingContext';

const _apiClient = new CheckmateApiClient();

export interface IOneTimeCodeModalProps {
    loginUser: ILoginUser;
    open: boolean;
    onClose: () => void;
    onSuccess: () => void;
}

export function OneTimeCodeModal(props: IOneTimeCodeModalProps) {
    const [oneTimeCode, setOneTimeCode] = React.useState<string>('');
    const [validation, setValidation] = React.useState<IValidation>();
    const loading = useLoading();

    const handleOneTimeCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const validationCopy = { ...validation };
        validationCopy.onetimecode = [];
        setValidation(validationCopy);

        const value = event.target.value;

        let data = value as string;
        if (data) {
            data = data.replace(/[^\d.-]/g, ''); // this must be done because if we change the type= 'number ' then the size of the field will be too small
            if (data.length > 6) {
                setOneTimeCode(data.substring(0, 6));
            } else {
                setOneTimeCode(data);
            }
        }
        setValidation({ onetimecode: [] });
        setOneTimeCode(data);
    };

    const handleClose = () => {
        setOneTimeCode('');
        props.onClose();
    };

    const handleSubmit = async () => {
        const validationCopy = { ...validation };
        validationCopy.onetimecode = [];
        setValidation(validationCopy);

        if (oneTimeCode.length === 0) {
            validationCopy.onetimecode = ['Code is Required'];
            setValidation(validationCopy);
            return;
        }

        loading.showLoading();
        await _apiClient.loginVerifyTwoFactorCode(props.loginUser, oneTimeCode).then((response) => {
            loading.hideLoading();

            if (response.payload?.invalidTwoFactorVerification) {
                const validationCopy = { ...validation };
                validationCopy.onetimecode = [response.payload?.message];
                setValidation(validationCopy);
            } else {
                props.onSuccess();
            }
        });
    };

    return (
        <Modal
            show={props.open}
            dialogClassName="onetimecode-dialog centered-modal"
            contentClassName="onetimecode-dialog-content"
            onHide={handleClose}
            backdrop
        >
            <Modal.Header>
                <Modal.Title>Two Factor Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{DisplayMessages.TwoFactorSubtitle}</p>
                <div className="mb-3">
                    <label className="control-label" htmlFor="onetimecode">
                        Two Factor Code*
                    </label>
                    <input
                        className="form-control"
                        type="text"
                        pattern="[0-9]"
                        autoComplete="one-time-code"
                        name="onetimecode"
                        value={oneTimeCode || ''}
                        onChange={handleOneTimeCodeChange}
                    />
                    <div className="text-danger">{validation?.onetimecode}</div>
                </div>
                <div>
                    <button
                        className="btn btn-black full-width vertical-margin"
                        onClick={handleSubmit}
                    >
                        Verify Code
                    </button>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    className="btn btn-default float-end vertical-margin-lg"
                    onClick={handleClose}
                >
                    Cancel
                </button>
            </Modal.Footer>
        </Modal>
    );
}
